export default __webpack_public_path__ + "static/media/car12.de4e5d0d.png";